module.exports = __webpack_public_path__ + "img/pm.89fc0beb.svg";